"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgNotifications(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M12 0a2 2 0 011.994 2.153c2.18.716 3.888 2.353 4 4.61L18 7v2l1.94 4.265c.175.34-.052.732-.425.786l-.088.007h-5.428a2 2 0 01-3.994.091l-.004-.092H4.569a.553.553 0 01-.542-.717l.034-.08L6 9V7c0-2.423 1.703-4.156 4.004-4.873L10 2a2 2 0 012-2z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Notifications')(SvgNotifications);
//# sourceMappingURL=Notifications.js.map